import { headerBlocks } from "./receipt-template.js";
import { printedDay } from "./statement.js";
const two = (value) => String(value).padStart(2, '0');
const stamp = (at) => `${printedDay(at)} ${two(at.getHours())}:${two(at.getMinutes())}`;
/** Zero escrito de todas as formas que o banco devolve. */
const isZero = (quantity) => /^-?0([.,]0+)?$/.test(quantity.trim());
export const stockReportFor = (input) => {
    const blocks = headerBlocks({
        company: input.company,
        template: input.template,
    });
    blocks.push({ kind: 'rule' }, {
        kind: 'text',
        text: 'RELATÓRIO DE ESTOQUE',
        align: 'center',
        bold: true,
    }, { kind: 'rule' }, { kind: 'pair', label: 'Filial', value: input.branchName }, { kind: 'pair', label: 'Emitido em', value: stamp(input.printedAt) }, {
        kind: 'pair',
        label: 'Filtro',
        value: input.filters.length === 0 ? 'sem filtro' : input.filters.join(', '),
    }, { kind: 'rule' });
    if (input.rows.length === 0) {
        blocks.push({
            kind: 'text',
            text: 'Nenhum item com este filtro.',
            align: 'center',
        });
    }
    for (const row of input.rows) {
        const name = row.sku === null ? row.description : `${row.sku} ${row.description}`;
        blocks.push({ kind: 'pair', label: name, value: row.onHand });
        /*
         * A segunda linha só existe quando há reserva.
         *
         * Escrever "reservado 0" em cada um de duzentos itens é papel gasto e
         * leitura mais lenta para achar o que importa.
         */
        if (!isZero(row.reserved)) {
            blocks.push({
                kind: 'pair',
                label: `  reservado ${row.reserved}`,
                value: `disp. ${row.available}`,
            });
        }
    }
    blocks.push({ kind: 'rule' }, {
        kind: 'pair',
        label: 'Itens listados',
        value: String(input.rows.length),
    });
    if (input.totals !== undefined) {
        blocks.push({ kind: 'pair', label: 'Unidades', value: input.totals.units }, { kind: 'pair', label: 'Custo', value: input.totals.costValue }, { kind: 'pair', label: 'Preço de venda', value: input.totals.saleValue }, {
            kind: 'pair',
            label: input.totals.marginPercent === null
                ? 'Lucro possível'
                : `Lucro possível (${input.totals.marginPercent.replace('.', ',')}%)`,
            value: input.totals.profitValue,
        });
    }
    if (input.totalRows > input.rows.length) {
        const left = input.totalRows - input.rows.length;
        blocks.push({
            kind: 'text',
            text: `ATENÇÃO: ${String(left)} ${left === 1 ? 'item ficou' : 'itens ficaram'}` +
                ' de fora. Este relatório está incompleto — filtre mais.',
            bold: true,
        });
    }
    blocks.push({ kind: 'feed', lines: 2 }, { kind: 'cut' });
    return { kind: 'report', title: 'Relatório de estoque', blocks };
};
//# sourceMappingURL=stock-report.js.map